import { dataMember, required, typedArray } from 'santee-dcts';

export class SponsorSubjectIdentity {
    @required({ nullable: true })
    @dataMember()
    public subjectNumber: string;

    @required()
    @dataMember()
    public subjectId: number;

    @required({ nullable: true })
    @dataMember()
    public zcSubjectId: string;

    @dataMember()
    @required({ nullable: true })
    public subjectInitials: string;

    @dataMember()
    @required({ nullable: true })
    public screeningNumber: string;

    @dataMember()
    @required({ nullable: true })
    public siteId: number;
}

export class SponsorSubjectIdentitiesReadModel {
    @dataMember()
    @required()
    @typedArray(SponsorSubjectIdentity)
    public subjectIdentities: SponsorSubjectIdentity[];
}
